const TOKEN_KEY = 'lgw-token'
const BALANCE_HINT_KEY = 'lgw-balance-hint'
const ALLOWED_GAMES_KEY = 'lgw-allowed-game-ids'
const PLATFORM_KEY = 'lgw-platform-code'
const RETURN_URL_KEY = 'lgw-return-url'

export function getLgwToken () {
  try {
    return localStorage.getItem(TOKEN_KEY) || ''
  } catch {
    return ''
  }
}

export function setLgwToken (token) {
  try {
    if (token) localStorage.setItem(TOKEN_KEY, token)
    else localStorage.removeItem(TOKEN_KEY)
  } catch (_) {}
}

export function setBalanceHint (balance) {
  try {
    if (balance === undefined || balance === null || balance === '') {
      localStorage.removeItem(BALANCE_HINT_KEY)
    } else {
      localStorage.setItem(BALANCE_HINT_KEY, String(balance))
    }
  } catch (_) {}
}

export function getBalanceHint () {
  try {
    const v = localStorage.getItem(BALANCE_HINT_KEY)
    return v == null ? null : Number(v)
  } catch {
    return null
  }
}

/** null = 不限制（全厅）；数组 = 仅这些彩种（系列入口，对齐 JDB） */
export function getAllowedGameIds () {
  try {
    const raw = localStorage.getItem(ALLOWED_GAMES_KEY)
    if (raw == null || raw === '') return null
    const ids = JSON.parse(raw)
    if (!Array.isArray(ids) || !ids.length) return null
    let list = ids.map(Number).filter((n) => n > 0)
    const lf = [14, 15, 16, 17]
    if (list.some((id) => lf.includes(id))) {
      const merged = [...new Set([...list, ...lf])]
      if (merged.length !== list.length) {
        try {
          localStorage.setItem(ALLOWED_GAMES_KEY, JSON.stringify(merged))
        } catch (_) {}
        list = merged
      }
    }
    return list.length ? list : null
  } catch {
    return null
  }
}

export function setAllowedGameIds (ids) {
  try {
    if (ids == null) {
      localStorage.removeItem(ALLOWED_GAMES_KEY)
      return
    }
    let list = (Array.isArray(ids) ? ids : [])
      .map(Number)
      .filter((n) => n > 0)
    // 低频彩成组：有 3D/双色球/大乐透时补上体彩P3P5
    const lf = [14, 15, 16, 17]
    if (list.some((id) => lf.includes(id))) {
      list = [...new Set([...list, ...lf])]
    }
    if (!list.length) localStorage.removeItem(ALLOWED_GAMES_KEY)
    else localStorage.setItem(ALLOWED_GAMES_KEY, JSON.stringify(list))
  } catch (_) {}
}

export function getPlatformCode () {
  try {
    return localStorage.getItem(PLATFORM_KEY) || ''
  } catch {
    return ''
  }
}

export function setPlatformCode (code) {
  try {
    if (code) localStorage.setItem(PLATFORM_KEY, String(code))
    else localStorage.removeItem(PLATFORM_KEY)
  } catch (_) {}
}

export function setReturnUrlHint (url) {
  try {
    if (url) localStorage.setItem(RETURN_URL_KEY, String(url))
    else localStorage.removeItem(RETURN_URL_KEY)
  } catch (_) {}
}

export function getReturnUrlHint () {
  try {
    return localStorage.getItem(RETURN_URL_KEY) || ''
  } catch {
    return ''
  }
}

/** 无显式 returnUrl 时，用 document.referrer 推断「谁把我打开的」 */
function inferReturnFromReferrer () {
  if (typeof document === 'undefined' || typeof window === 'undefined') return ''
  try {
    const r = String(document.referrer || '').trim()
    if (!r) return ''
    const u = new URL(r)
    if (u.origin === window.location.origin) return ''
    if (/:(8080)$/i.test(u.host)) return ''
    return `${u.origin}/`
  } catch {
    return ''
  }
}

function betPathForId (gameId) {
  const id = Number(gameId)
  if (id === 14) return '/bet/fc3d'
  if (id === 16) return '/bet/dlt'
  if (id === 17) return '/bet/ssq'
  if (id === 1103) return '/bet/tc-lhc'
  if (id === 1909) return '/bet/tc-k3'
  if (id === 21503) return '/bet/tc-keno8'
  return '/bet'
}

function parseQueryIdList (raw) {
  if (raw == null || raw === '') return []
  return String(raw)
    .split(/[,|\s]+/)
    .map(Number)
    .filter((n) => Number.isFinite(n) && n > 0)
}

/**
 * 用 GET 参数控制本次进厅可见彩种（优先于 SSO ticket 范围）
 * ?allowedGameIds=14,17 或 ?games=14,17
 * ?all=1 表示全部
 * ?platformCode= &returnUrl=
 * 返回是否改写了可见范围
 */
export function applyEntryQueryParams () {
  if (typeof window === 'undefined') return false
  const url = new URL(window.location.href)
  let changed = false

  const platform = url.searchParams.get('platformCode') || url.searchParams.get('platform')
  if (platform != null && String(platform).trim() !== '') {
    setPlatformCode(String(platform).trim())
    changed = true
  }

  const ret = url.searchParams.get('returnUrl')
  if (ret != null && String(ret).trim() !== '') {
    setReturnUrlHint(String(ret).trim())
    changed = true
  } else {
    const inferred = inferReturnFromReferrer()
    if (inferred) {
      setReturnUrlHint(inferred)
      changed = true
    }
  }

  const allFlag = url.searchParams.get('all')
  const rawIds =
    url.searchParams.get('allowedGameIds') ||
    url.searchParams.get('games') ||
    url.searchParams.get('gameIds')

  if (allFlag === '1' || allFlag === 'true') {
    setAllowedGameIds(null)
    changed = true
  } else if (rawIds != null) {
    const ids = parseQueryIdList(rawIds)
    setAllowedGameIds(ids.length ? ids : null)
    changed = true
  }

  // 清掉控制参数，避免地址栏长期残留；保留 id/gameId/token 等业务参数
  ;['allowedGameIds', 'games', 'gameIds', 'all', 'platformCode', 'platform', 'returnUrl'].forEach(
    (k) => url.searchParams.delete(k)
  )
  if (changed) {
    const cleaned =
      url.pathname + (url.searchParams.toString() ? `?${url.searchParams}` : '') + url.hash
    window.history.replaceState({}, '', cleaned)
  }
  return changed
}

/**
 * 从 URL 只吃一次性 SSO token（兼容旧参数名 ticket），
 * 余额/用户信息一律由 /lgw/sso/exchange 查 Helala 表返回，不信任 URL 字段。
 */
export async function bootstrapHelalaSso () {
  if (typeof window === 'undefined') return null
  const url = new URL(window.location.href)

  // GET 控彩：优先应用（可覆盖后续 SSO 默认全厅）
  const hasGetScope =
    url.searchParams.has('allowedGameIds') ||
    url.searchParams.has('games') ||
    url.searchParams.has('gameIds') ||
    url.searchParams.has('all')
  const getPlatform =
    url.searchParams.get('platformCode') || url.searchParams.get('platform')
  const getReturn = url.searchParams.get('returnUrl')
  applyEntryQueryParams()

  const ssoToken =
    url.searchParams.get('token') ||
    url.searchParams.get('ticket') ||
    ''

  if (!ssoToken) {
    if (!hasGetScope) return null
    // 仅 GET 控彩：纠正 active，必要时直达投注页
    const allowed = getAllowedGameIds()
    if (allowed?.length === 1) {
      const only = Number(allowed[0])
      try {
        localStorage.setItem('active-game-id', String(only))
      } catch (_) {}
      const path = betPathForId(only)
      const u = new URL(window.location.href)
      ;['allowedGameIds', 'games', 'gameIds', 'all', 'platformCode', 'platform', 'returnUrl'].forEach(
        (k) => u.searchParams.delete(k)
      )
      u.searchParams.set('id', String(only))
      window.history.replaceState(
        {},
        '',
        `${path}?${u.searchParams.toString()}${u.hash}`,
      )
    }
    return { fromQuery: true }
  }

  // 重新读当前地址（applyEntryQueryParams 可能已改写）
  const url2 = new URL(window.location.href)
  const tokenStill =
    url2.searchParams.get('token') ||
    url2.searchParams.get('ticket') ||
    ssoToken

  const res = await fetch('/lgw/sso/exchange', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ token: tokenStill })
  })
  const json = await res.json().catch(() => null)
  if (!json || !json.success || !json.data?.token) {
    throw new Error(json?.message || 'SSO 登录失败')
  }

  setLgwToken(json.data.token)
  if (json.data.balance != null) setBalanceHint(json.data.balance)

  // GET 已指定范围则不覆盖；否则用 SSO ticket 范围
  if (!hasGetScope) {
    setAllowedGameIds(json.data.allowedGameIds)
  }
  if (!getPlatform) setPlatformCode(json.data.platformCode || '')
  if (!getReturn) {
    const fromSso = String(json.data.returnUrl || '').trim()
    const inferred = fromSso || inferReturnFromReferrer()
    if (inferred) setReturnUrlHint(inferred)
  }

  // 清掉 SSO 参数，避免刷新重复消费 / 地址栏残留；保留 id/gameId 便于直达彩种
  const url3 = new URL(window.location.href)
  ;['token', 'ticket', 'balance', 'currency', 'allowedGameIds', 'games', 'gameIds', 'all', 'platformCode', 'platform', 'returnUrl'].forEach(
    (k) => url3.searchParams.delete(k)
  )
  const allowed = getAllowedGameIds()
  let entryGameId = Number(json.data.gameId || url3.searchParams.get('id') || 0)
  // 控彩仅 1 款时强制落到该彩种（覆盖本地残留的快乐8等 active）
  if (allowed?.length === 1) {
    entryGameId = Number(allowed[0])
  } else if (entryGameId > 0 && allowed?.length && !allowed.includes(entryGameId)) {
    entryGameId = Number(allowed[0])
  }
  if (entryGameId > 0) {
    url3.searchParams.set('id', String(entryGameId))
    try {
      localStorage.setItem('active-game-id', String(entryGameId))
    } catch (_) {}
  }
  // 仅一款时直达对应投注页
  let path = url3.pathname
  if (allowed?.length === 1 && entryGameId > 0) {
    path = betPathForId(entryGameId)
  }
  const cleaned = path + (url3.searchParams.toString() ? `?${url3.searchParams}` : '') + url3.hash
  window.history.replaceState({}, '', cleaned)

  return { ...json.data, gameId: entryGameId || json.data.gameId }
}

/**
 * 点击「首页」：回 Helala 主站，并带上 Helala JWT（ssoToken）保持登录
 * 跨域时 localStorage 不共享，必须靠 URL 回写 token。
 */
export async function goHelalaHall () {
  const token = getLgwToken()
  const headers = { 'Content-Type': 'application/json' }
  if (token) headers.Authorization = `Bearer ${token}`

  let url = ''
  try {
    const res = await fetch('/lgw/sso/return-home', {
      method: 'POST',
      headers,
      body: '{}'
    })
    const json = await res.json().catch(() => null)
    if (json?.success && json.data?.url) {
      url = json.data.url
    }
  } catch (_) {}

  if (!url) {
    url =
      getReturnUrlHint() ||
      inferReturnFromReferrer() ||
      (typeof process !== 'undefined' && process.env?.VUE_APP_HELALA_H5_URL) ||
      'https://h5.tgwebbot.com/'
  }

  // 彩票常嵌在 Helala /gameDetail iframe：必须顶层跳转。
  // 若只改 iframe 到 5500/，父页 onload 会误判「已回主站」并 history.back → 游戏列表。
  try {
    if (window.top && window.top !== window) {
      window.top.location.href = url
      return
    }
  } catch (_) {
    // 跨域读 top 失败时仍尝试赋值（多数浏览器允许写 top.location）
    try {
      window.top.location.href = url
      return
    } catch (__) {}
  }
  window.location.href = url
}

/**
 * 启动时准备会话：先兑 URL SSO；再校验本地 token，失效则清除。
 * 避免进页用过期 token 连续打出 accounts/settings/cart 401。
 */
export async function ensureLgwSession () {
  if (typeof window === 'undefined') return null
  try {
    await bootstrapHelalaSso()
  } catch (_) {
    /* SSO 失败不阻断进厅；后续走演示或已有会话 */
  }

  const t = getLgwToken()
  if (!t || t === 'lgw-demo') return getLgwToken() || null

  try {
    const res = await fetch(`/lgw/sessions/${encodeURIComponent(t)}`, {
      headers: { Authorization: `Bearer ${t}` }
    })
    const json = await res.json().catch(() => null)
    if (!res.ok || !json?.success) {
      setLgwToken('')
      return null
    }
    return t
  } catch (_) {
    return t
  }
}
